import EventBus from '@/services/eventBus.js'

export default{
    loading(){
        EventBus.$emit('startLoading');
    },
    stopLoading(){
        EventBus.$emit('dismissLoading');
    }
}


// WEBPACK FOOTER //
// ./src/services/utilities.js